<template>
  <div class="popupLottieCircular">
    <div class="circular one"></div>
    <div class="circular two"></div>
    <div class="circular three"></div>
  </div>
</template>
<script>

export default {
  name: 'popupCircular'
};
</script>
<style lang="less" scoped>
@cirWidth: 3.5rem;

.popupLottieCircular {
  position: absolute;
  // z-index: 1 !important;
  width: @cirWidth;
  height: @cirWidth;
  left: 50%;
  top: 45%;
  transform: translateX(-50%) translateY(-50%);
  .circular {
    position: absolute;
    width: @cirWidth;
    height: @cirWidth;
    border-radius: 50%;
    box-sizing: border-box;
  }
  .one {
    animation: cir1 2s linear infinite;
    border: 2px solid #FFEEAF;
  }
  .two {
    animation: cir2 3s linear infinite;
    border: 4px solid #CCFFCC;
  }
  .three {
    animation: cir3 4s linear infinite;
    border: 1px solid #A5A7FF;
  }
}

@keyframes cir1 {
  0%{
    transform: scale(0);
    opacity: 1;
    border-color: #FFEEAF;
  }
  50% {
    filter: blur(1px);
  }
  100%{
    transform: scale(3);
    opacity: 0;
    border-color: #FF928E;
    filter: blur(5px);
  }
}
@keyframes cir2 {
    0%{
      transform: scale(0);
      opacity: 1;
      border-color: #CCFFCC;
    }
    50% {
        filter: blur(1px);
    }
    100%{
      transform: scale(3);
      opacity: 0;
      border-color: #FFEBC0;
      filter: blur(5px);
    }
  }
  @keyframes cir3 {
    0%{
      transform: scale(0);
      opacity: 1;
      border-color: #A5A7FF;
    }
    50% {
        filter: blur(1px);
    }
    100%{
      transform: scale(3);
      opacity: 0;
      border-color: #FFABC2;
      filter: blur(5px);
    }
  }
</style>
